module.exports = __webpack_public_path__ + "static/media/branded-spinner.b1fe3b06.gif";